var _ellipse, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 12,
    rx: 9.5,
    ry: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 23C5.15887 23 0 17.8411 0 11.5C0 5.15887 5.15887 0 11.5 0C17.8411 0 23 5.15887 23 11.5C23 17.8411 17.8411 23 11.5 23ZM17.4637 15.5399C17.6055 15.5399 17.7209 15.4245 17.7209 15.2827V8.06298L11.8698 12.7093C11.7616 12.7954 11.6307 12.8384 11.5 12.8384C11.3692 12.8384 11.2384 12.7953 11.1301 12.7093L5.27904 8.06298V15.2827C5.27904 15.4245 5.39444 15.5399 5.53622 15.5399H17.4637ZM16.5671 7.46013L11.5 11.484L6.43286 7.46013H16.5671ZM18.9106 7.71731V15.2828C18.9106 16.0805 18.2615 16.7296 17.4637 16.7296H5.53622C4.7384 16.7296 4.08942 16.0805 4.08942 15.2828V7.71731C4.08942 6.91954 4.73845 6.27051 5.53622 6.27051H17.4637C18.2615 6.27046 18.9106 6.91954 18.9106 7.71731Z",
    fill: "url(#paint0_linear_1289_2370)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1289_2370",
    x1: 11.9907,
    y1: 0,
    x2: 11.9907,
    y2: 20.5074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998403,
    stopColor: "#F94327"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2fafe10b226381032bf1a1f7871f7dbe.svg";
export { ForwardRef as ReactComponent };